import { Box, Flex, FormControl, FormLabel, Img, Input, Select, Stack, Text, Textarea, SlideFade } from '@chakra-ui/react';
import React, { useState } from 'react';
import Container from '../../components/Container';
import Header from '../../components/Header';
import { formLabelStyles, issueTypes } from './components/issueReportData';
import { RiCameraLensLine } from 'react-icons/ri';
import { PrimaryButton } from '../../components/CustomButton';
import OneIssue from './components/OneIssue';
import { infoNotifier } from '../../components/NotificationHandler';
import Footer from '../../components/footer';
import { PROTECTED_PATHS } from '../../app/constants';
import { Link } from 'react-router-dom';

const IssueReport = () => {
  const [issueType, setIssueType] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [media, setMedia] = useState([]);
  const [previewImg] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayOneIssue, setDisplayOneIssue] = useState(false);
  const { ISSUE_REPORTS_HISTORY } = PROTECTED_PATHS;

  const handleImage = (event) => {
    if (!event.target.files) return;

    if (Array(...event.target.files).length > 5) {
      infoNotifier('Pick a maximum of Three Images');
      return;
    }
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      setMedia((prev) => [...prev, { imgUrl: reader.result, file: event.target.files[0] }]);
    };
  };

  const handleOneIssueDisplay = () => {
    if (issueType && title && description) {
      setDisplayOneIssue(true);
      return;
    }
    infoNotifier('Please Fill in the Details');
  };

  return !displayOneIssue ? (
    <SlideFade in={true} offsetX='-2000px'>
      <Box minH='100vh'>
        <Box shadow='sm'>
          <Container>
            <Header menu />
          </Container>
        </Box>

        <Container minH='calc(100vh - 100px)'>
          <FormControl h='100%'>
            <Stack py='5' spacing='5'>
              <Select
                placeholder='Report Type'
                _focus={{ border: '1px solid #F9C8C5' }}
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
              >
                {issueTypes?.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </Select>

              <Input
                placeholder='Title'
                border='none'
                borderBottom='1px solid #ccc'
                borderRadius='0'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <Textarea placeholder='Details...' resize='none' rows='6' value={description} onChange={(e) => setDescription(e.target.value)} />
            </Stack>

            <Flex mt='5' gap='10px'>
              <Box>
                <Text color='#516395' fontWeight='500'>
                  Add Media
                </Text>
                <FormLabel {...formLabelStyles}>
                  <RiCameraLensLine size={30} color='#fff' />
                  <Input type='file' display='none' id='media' onChange={handleImage} />
                </FormLabel>
              </Box>
              <Flex wrap={'wrap'}>
                {media?.map((medium, i) => {
                  return <Img key={i} w='70px' h='70px' m='2' borderRadius={'5px'} src={medium.imgUrl} alt={medium.file.name} />;
                })}
              </Flex>
            </Flex>
            <Box pt='10vh'>
              <PrimaryButton btnText='Send Report' isLoading={loading} onClick={handleOneIssueDisplay} />
            </Box>
          </FormControl>
          <Text textAlign='center' py='10' fontWeight='600'>
            <Link to={ISSUE_REPORTS_HISTORY}>Goto report history</Link>
          </Text>
        </Container>
        <Footer />
      </Box>
    </SlideFade>
  ) : (
    <OneIssue
      setDisplayOneIssue={setDisplayOneIssue}
      media={media}
      description={description}
      issueType={issueType}
      title={title}
      previewImg={previewImg}
      setLoading={setLoading}
    />
  );
};

export default IssueReport;
